import debounce from 'p-debounce';
import {
  APPLIANCE_DEVICES_FETCH_SUCCEEDED,
  ALL_APPLIANCE_DEVICES_SOCKET_UPDATE
} from '#action/types';

const updateCardPage = debounce((store, device) => {
  const { applianceDevices: { applianceDevices } } = store.getState();
  const updatedDevices = applianceDevices.reduce((acc, rec) => [...acc, {
    ...rec,
    devices: rec.devices.map(d => (d.uid === device.uid ? { ...d, ...device } : d))
  }], []);
  store.dispatch({
    type: APPLIANCE_DEVICES_FETCH_SUCCEEDED,
    payload: updatedDevices
  });
}, 3000);

const updateOverviewPage = debounce((store, device) => {
  const { applianceDevices: { allDevices } } = store.getState();
  store.dispatch({
    type: ALL_APPLIANCE_DEVICES_SOCKET_UPDATE,
    payload: allDevices.map(d => (d.uid === device.uid ? { ...d, ...device } : d))
  });
}, 3000);

export default ({
  isApplianceCardsPage(store, uid) {
    const { applianceDevices: { applianceDevices } } = store.getState();
    const isPresent = applianceDevices.reduce((acc, rec) =>
      (rec.devices.find(d => d.uid === uid) ? true : acc), false);
    return isPresent;
  },
  updateApplianceCardsPage(store, device) {
    updateCardPage(store, device);
  },
  isApplianceOverviewPage(store, deviceUid) {
    const { applianceDevices: { allDevices } } = store.getState();
    return allDevices.find(d => d.uid === deviceUid);
  },
  updateApplianceOverviewPage(store, device) {
    updateOverviewPage(store, device);
  }
});
